var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav-list",
      style: {
        padding: _vm.navPadding,
      },
    },
    [
      _vm.propsData.menus && _vm.propsData.menus.length > 0
        ? _c(
            "div",
            { staticClass: "list" },
            _vm._l(_vm.propsData.menus, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "nav-item",
                  style:
                    _vm.propsData.menus.length > 5
                      ? "margin-right: 15px"
                      : "margin-right: 20px",
                },
                [
                  [
                    item && item.pic
                      ? _c("img", {
                          staticClass: "img",
                          attrs: { src: item.pic },
                        })
                      : _c("img", {
                          staticClass: "img",
                          attrs: {
                            src: require("../../../../../../../assets/imgs/app.png"),
                          },
                        }),
                  ],
                  _vm._v(" "),
                  _c("div", { staticClass: "text ellipsis1" }, [
                    _vm._v(_vm._s(item && item.name)),
                  ]),
                ],
                2
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }